import { Button, Layout, Modal, Typography } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"

interface UpdateAvailableDialogProps {
    open: boolean
    availableVersion?: string
    onUpdate: () => void
    onLater: () => void
}

export const UpdateAvailableDialog = ({
    open,
    availableVersion,
    onUpdate,
    onLater
}: UpdateAvailableDialogProps) => {
    const { t } = useTranslation()
    return (
        <Modal
            open={open}
            backdrop
            maxWidth="min(500px, calc(100vw - 32px))"
            header={
                <Typography variant="h3" align="center">
                    {t("アップデートのお知らせ")}
                </Typography>
            }
            body={
                <Layout.Column gap={4}>
                    <div>
                        <Typography
                            align="center"
                            style={{ whiteSpace: "pre-line" }}
                        >
                            {availableVersion
                                ? t(
                                      "バージョン {{version}} が公開されました。\nストアから更新してください。",
                                      { params: { version: availableVersion } }
                                  )
                                : t(
                                      "新しいバージョンが公開されました。\nストアから更新してください。"
                                  )}
                        </Typography>
                    </div>
                </Layout.Column>
            }
            footer={
                <Layout.Row gap={1} nowrap>
                    <Button variant="filled" fullWidth onClick={onLater}>
                        {t("後で")}
                    </Button>
                    <Button
                        variant="filled"
                        color="primary"
                        fullWidth
                        onClick={onUpdate}
                    >
                        {t("更新する")}
                    </Button>
                </Layout.Row>
            }
        />
    )
}
